import React from 'react';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import Icon from '@ant-design/icons';
import { ButtonType, Button, ButtonPropsType } from 'components/Controls/Button';
import MaterialsSvg from './materials.svg';

interface MaterialButton extends ButtonPropsType {
  iconSize?: number;
}

export const MaterialsIcon = (props: any) => <Icon component={MaterialsSvg} {...props} />;

export const MaterialsIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, MaterialButton>(
  ({ size = 'medium', iconSize = 24, ...props }, ref) => (
    <Button
      ref={ref}
      type={ButtonType.OutlineIcon}
      icon={<MaterialsSvg width={iconSize} height={iconSize} />}
      size={size as SizeType}
      {...props}
    />
  ),
);
MaterialsIconButton.displayName = 'MaterialsIconButton';
